











import Vue from "vue"
import EditLinkIcon from "~/components/guideline/icon/EditLinkIcon.vue"

export default Vue.extend({
  components: {
    EditLinkIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    iconLinkPath: {
      type: String,
      default: null,
    },
  },
})
